export default __webpack_public_path__ + "static/media/metrics-positions.bd42e114.svg";